import TableList from "@components/templates/tablelist";
import {
    HttpServiceManageList,
    HttpActiveServiceManageOne
} from "@/service/credit";
import { mapGetters } from "vuex";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpServiceManageList,
        handleOperates(params = "", type, batch) {
            switch (type) {
                case "query":
                    this.operate = {
                        show: true,
                        activeid:params,
                        title: "查看",
                        component: "compUpdate",
                        width: 1100,
                        showFooter: false,
                        querytype:'query'
                    };
                    break;
                case "edit":
                    var url = this.$router.resolve({
                        name: "rulesServicemanageUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "add":
                    this.$router.push({
                        name: 'rulesServicemanageUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "active":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params,status:0 },
                        title: "启用",
                        ajaxRequest: HttpActiveServiceManageOne
                    };
                    break;
                case "noactive":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params,status:1 },
                        title: "禁用",
                        ajaxRequest: HttpActiveServiceManageOne
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id,status } = row;
            return [
                {
                    label: "查看详情",
                    params: id,
                    show: true,
                    operate: "query"
                },
                {
                    label: "编辑",
                    params: id,
                    show: status == 0,
                    operate: "edit"
                },
                {
                    label: "启用",
                    params: id,
                    show: status != 0,
                    operate: "active"
                },
                {
                    label: "禁用",
                    params: id,
                    show: status == 0,
                    operate: "noactive"
                },
            ];
        }
    },
    computed: {
        ToolsData() {
            return [
                {
                    label: "添加",
                    operate: "add",
                    theme: "primary"
                }
            ];
        },
        SearchsData() {
            return [
                {
                    label: "服务商编码",
                    key: 'EQ_providerCode',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "服务商名称",
                    key: 'EQ_providerName',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "状态",
                    key: 'EQ_status',
                    tag: 'vSelect',
                    options: [
                        { value: 0, label: '启用' },
                        { value: 1, label: '禁用' },
                    ],
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    show: true,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                    style: "width:250px",
                },
            ];
        },
        columns() {
            return [
                {
                    title: "操作",
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: "服务商编码",
                    key: "providerCode"
                },
                {
                    title: "服务商名称",
                    key: "providerName"
                },
                {
                    title: "状态",
                    key: "status",
                    render:(h,{row})=>{
                        return <div>{row.status == 0 ? '启用' : '禁用'}</div>
                    }
                },
                {
                    title: "创建日期",
                    key: "createdAt",
                    sortable: true
                },
            ];
        }
    }
};
